// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__oXuav","bottomNavigationContainer":"navbar_bottomNavigationContainer__sowZ2","Mui-selected":"navbar_Mui-selected__k3-GE"};